import { render, staticRenderFns } from "./yek-valmistumispyynnot-list.vue?vue&type=template&id=44d1b490&scoped=true&"
import script from "./yek-valmistumispyynnot-list.vue?vue&type=script&lang=ts&"
export * from "./yek-valmistumispyynnot-list.vue?vue&type=script&lang=ts&"
import style0 from "./yek-valmistumispyynnot-list.vue?vue&type=style&index=0&id=44d1b490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d1b490",
  null
  
)

export default component.exports